import React, { useState } from 'react';
const AjaxFunctions = require('../ajaxFunctions');
const Utils = require('../utils');
const ToastAlert = require('./toastAlert');
const Scroll = require('react-scroll');
const moment = require('moment');

import ZoomMtgEmbedded from '@zoomus/websdk/embedded';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Grid, Select, InputLabel, Button, Typography, TextField, Paper , List, ListItem} from '@material-ui/core';
import { DiscussionTopicCard, DiscussionCommentCard, CommentSubmissionBox } from './discussionCard';
import { ConfirmationModal } from './confirmationModal.jsx';
import YouTube from 'react-youtube';
import socketIOClient from "socket.io-client";
import { DiscussionFAB } from './discussionFAB.js';
import Fuse from 'fuse.js'
let socket = null;

function NewCommentList(props){
    let [isExpanded, setIsExpanded] = useState(true);
    return(
       <Paper id={'new-comments-list'} style={{
           maxHeight: '300px',
           width: '200px',
           overflow: 'auto',
           position: 'fixed',
           zIndex: '100',
           right: '30px',
           bottom: '36px'
       }}>
           <div
              id={'new-comments-list-header'}
              style={{
                  background: '#3f51b5',
                  color: 'white',
                  paddingLeft: '10px',
                  paddingTop: '10px',
                  height: '40px',
                  cursor: 'pointer'
              }}
              onClick={() => setIsExpanded(!isExpanded)}
           >
               <span>Comments Ticker</span>
               <span
                  style={{
                      cursor: 'pointer',
                      float: 'right',
                      fontSize: '17px',
                      paddingRight: '10px',
                      paddingLeft: '10px'
                  }}
               >
                   {isExpanded ? '-' : '+'}
               </span>

           </div>
           <List
              style={{
                  maxHeight: isExpanded ? '260px' : '0',
                  overflowY: isExpanded ? 'scroll' : 'hidden',
              }}
           >
               {
                   props.flatNumberedComments.map(comment => {
                       let hasBeenClicked = window.localStorage.getItem(comment.idCardComment)
                       let itemStyle = {
                           textDecoration: 'underline',
                           cursor: 'pointer'
                       }
                       if(!hasBeenClicked){
                           itemStyle.fontWeight = '800';
                           itemStyle.fontSize = 'larger';
                       }
                       return(
                           <ListItem key={`anchor-${comment.idCardComment}`}
                                     style={itemStyle}
                                     onClick={() => {
                                         props.expandToShowComment(comment.idCardComment);
                                         Scroll.scroller.scrollTo(`comment-${comment.idCardComment}`, {
                                             smooth: true,
                                             offset: -80,
                                         })
                                         window.localStorage.setItem(comment.idCardComment, 'clicked');
                                     }}>
                               {comment.order}
                           </ListItem>
                       )
                   })
               }
           </List>
       </Paper>
    )
}

export class PortfolioDiscussionTab extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            allComments: [],
            commentText: '',
            parentComment: '',
            enableSubmitButton: true,
            commentSort: 'mr',
            childComments: new Set(),
            sponsorTypingResponse: null,
            commentToDelete: {},
            showDeleteModal: false,
            discussionSearchFilter: '',
            comments:[]
        };
    }

    async updateComments(){
        let comments = await AjaxFunctions.getIncubatorThreads(this.props.portfolio.id);
        comments = Utils.formatComments(comments.flat());
        this.setState({ allComments: comments });
    }

    async componentDidMount() {
        let comments = await AjaxFunctions.getIncubatorThreads(this.props.portfolio.id);
        comments = Utils.formatComments(comments.flat());
        if (comments.length == 0 && !history.state.prevTab) {
            this.props.tabChange('overview');
        }
        let sharedCommentId = Utils.getParameterByName('idComment', window.location.href);

        expandToShowComment(comments, sharedCommentId);

        this.setState({ allComments: comments, sharedCommentId });
        socket = socketIOClient(window.globals.socketConnection, { transports: ["websocket"] });

        socket.on(`UpdatePortfolio${this.props.portfolio.id}`, async data => {
            let allComments = Utils.formatComments(data.flat());
            this.setState({ allComments });
        });

        socket.on(`UpdatePortfolio${this.props.portfolio.id}SponsorTyping`, async data => {
            this.setState({ sponsorTypingResponse: data });
        });

        if (sharedCommentId) {
            Scroll.Events.scrollEvent.register('end', (to, element) => {
                element.className += ' scroll-reached';
            });
            Scroll.scroller.scrollTo(`comment-${sharedCommentId}`, {
                smooth: true,
                offset: -80,
            });
        }
    }

    componentWillUnmount() {
        if (socket) {
            socket.disconnect();
        }
        Scroll.Events.scrollEvent.remove('end');
    }

    async handleDeleteComment(comment) {
        const { idCardComment, idPortfolio, childComments = [], idThread } = comment;
        await AjaxFunctions.deletePortfolioComment(idCardComment, idPortfolio, idThread, childComments.length);
    }

    async handleLikeComment(comment) {
        try {
            const { idCardComment, idPortfolio, idThread } = comment;
            await AjaxFunctions.likePortfolioComment(idCardComment, idPortfolio, idThread);
        } catch (err) {
            ToastAlert.error(err);
        }
    }

    async handleDisableComment(comment) {
        try {
            const { idCardComment, idPortfolio, isDisabled, idThread } = comment;
            await AjaxFunctions.disablePortfolioComment(idCardComment, idPortfolio, idThread, isDisabled);
        } catch (err) {
            ToastAlert.error(err);
        }
    }

    async handlePinComment(comment) {
        try {
            const { idCardComment, idPortfolio, isPinned, idThread } = comment;
            await AjaxFunctions.pinPortfolioComment(idCardComment, idPortfolio, idThread, isPinned);
        } catch (err) {
            ToastAlert.error(err)
        }
    }

    async handleEditComment(comment, text) {
        const { idCardComment, idPortfolio, idThread } = comment;
        await AjaxFunctions.editPortfolioComment(idCardComment, idPortfolio, idThread, text);
    }

    handleSubmitThread(_, text) {
        if (text == '') {
            ToastAlert.error('Thread content cannot be blank.');
        } else {
            this.setState({ enableSubmitButton: false });
            AjaxFunctions.createIncubatorThread(this.props.portfolio.id, '', text).then(() => {
                ToastAlert.success("Your discussion thread has been submitted!");
                this.setState({ text: '', enableSubmitButton: true });
            });
            this.state.childComments.clear();
        }
    };

    handleSubmitComment(comment, text) {
        let usersToNotify = new Set();

        comment.childComments.forEach(c => {
            if (c.user.idUser !== parseInt(window.globals.idUser)) {
                usersToNotify.add(c.user.idUser);
            }
        });

        if (comment.user.idUser !== parseInt(window.globals.idUser)) {
            usersToNotify.add(comment.user.idUser);
        }

        AjaxFunctions.createPortfolioComment(
            comment.idPortfolio,
            comment.idThread,
            comment.idCardComment,
            '',
            text
        ).then(c => {
            if (usersToNotify.size > 0) {
                AjaxFunctions.notifyCommenters(
                    comment.idPortfolio,
                    comment.idCardComment,
                    c.idCardComment,
                    [...usersToNotify]
                );
            }
            ToastAlert.success('Your discussion comment has been submitted!');
        });
    }

    checkIncubatorOwners(idToCheck) {
        const { portfolio } = this.props;
        return portfolio.idOwner == idToCheck
            || portfolio.owners.find(owner => owner.idUser == idToCheck);
    }

    render() {
        const { allComments, commentSort, showDeleteModal, threadToDelete, sharedCommentId } = this.state;
        const { portfolio, useTopics } = this.props;
        let allUsers = allComments.map(c =>
            [c.user, ...c.childComments.map(ch => ch.user)]
        ).flat();

        let eventHandlers = {
            onLike: comment => this.handleLikeComment(comment),
            onPin: comment => this.handlePinComment(comment),
            onDelete: comment => this.setState({ showDeleteModal: true, threadToDelete: comment }),
            onSubmit: (comment, text) => this.handleSubmitComment(comment, text),
            onDisable: comment => this.handleDisableComment(comment),
            onEdit: (comment, text) => this.handleEditComment(comment, text),
        };

        const typingFunction = (isTyping, comment) => {
            if (this.checkIncubatorOwners(window.globals.idUser)) {
                AjaxFunctions.updatePortfolioSponsorTyping(isTyping, portfolio.id, comment)
            }
        }

        const addComment = (c) => {

        }
        const commentProps = c => {
            return {
                key: c.idCardComment,
                isExpandable: true,
                isExpanded: c.childComments.some(child => child.idCardComment == sharedCommentId),
                comment: c,
                isSponsor: idUser => this.checkIncubatorOwners(idUser),
                isOwner: idUser => this.checkIncubatorOwners(idUser),
                typingFunction: (isTyping, comment) => typingFunction(isTyping, comment),
                eventHandlers: eventHandlers,
                allUsers: allUsers,
                updateCommentTree: () => this.updateComments(),
                order: c.order,
            };
        };

        const sortAndNumber = (comment) => {
            if(comment.childComments.length > 0){
                comment.childComments.sort((a,b) => new Date(a.creationTime).getTime() - new Date(b.creationTime).getTime())
                .map((c, i) => {
                    let nums = comment.order.split('.').slice();
                    let lastNum = nums.pop();
                    let tail = lastNum ==='0' ? nums.join('.') : comment.order;
                    c.order = `${tail}.${i+1}`;
                    if(c.childComments.length > 0)
                        sortAndNumber(c);
                    return c;
                })
            }
        }

        const numberedComments = allComments.sort((a, b) =>
            new Date(a.creationTime).getTime() - new Date(b.creationTime).getTime()
        ).map((comment, index) => {
            comment.order = `${index+1}.0`;
            sortAndNumber(comment);
            return comment;
        });

        const mergeAll = (array, comment) => {
            array.push(comment);
            if(comment.childComments.length > 0) {
                comment.childComments.forEach(c =>{
                    mergeAll(array, c);
                })
            }
        }
        let flatNumberedComments = [];
        numberedComments.forEach(comment => {
            if(comment.childComments.length > 0)
                mergeAll(flatNumberedComments, comment);
            else
                flatNumberedComments.push(comment);
        });
        flatNumberedComments.sort((a, b) => new Date(b.creationTime).getTime() - new Date(a.creationTime).getTime())

        const pinnedComments = numberedComments
            .filter(c => c.isPinned)
            .map(c => useTopics ? (
                <DiscussionTopicCard
                    key={c.idCardComment}
                    {...commentProps(c)}
                />
            ) : (
                    <DiscussionCommentCard
                        addComment={comment=>addComment(comment)}
                        key={c.idCardComment}
                        {...commentProps(c)}
                    />
                ))

        let allFilteredComments = numberedComments;
        let allowHide = false;
        if (this.state.discussionSearchFilter !== ''){
            allowHide = true;

            let showAllDescendants = (comment) => {
                comment.childComments.forEach((child) => {
                    child.hide = false;
                    child.shouldExpand = false;
                    showAllDescendants(child);
                })
            }

            let recursiveFilter = (comment) => {
                comment.hide = true;
                comment.childComments.forEach(child => {
                    let foundDescendant = recursiveFilter(child);
                    if(foundDescendant){
                        comment.hide = false;
                        comment.shouldExpand = true;
                    }
                })

                if(comment.childComments && comment.childComments.filter(x => !x.hide).length > 0){
                    return true;
                }

                let fuse = new Fuse(
                   [comment],
                   {
                       includeScore: false,
                       ignoreLocation: true,
                       threshold: 0.3,
                       keys: ['text'],
                       includeMatches: true,
                   }
                );
                let fuseResults = fuse.search(this.state.discussionSearchFilter);
                if(fuseResults.length > 0){
                    comment.hide = false;
                    comment.shouldExpand = false;
                    showAllDescendants(comment);
                }
                return !comment.hide;
            }

            let root = {
                childComments: allFilteredComments
            }
            recursiveFilter(root);
            //let searchResults = allCommentsFuse.search(this.state.discussionSearchFilter);
            //allFilteredComments = searchResults.map(cur => cur.item);
        }

        const sortedComments = allFilteredComments
            .filter(c => !c.isPinned)
            .sort((a, b) => commentSort != 'mr'
                ? b.likes.length - a.likes.length
                : new Date(a.creationTime).getTime() - new Date(b.creationTime).getTime()
            )
            .map(c => useTopics ? (
                <DiscussionTopicCard
                    key={c.idCardComment}
                    topThread = {true}
                    order = {c.order}
                    {...commentProps(c)}
                />
            ) : (
                    <DiscussionCommentCard
                        key={c.idCardComment}
                        topThread = {true}
                        order = {c.order}
                        addComment={comment=>addComment(comment)}
                        allowHide={allowHide}
                        {...commentProps(c)}
                    />
                ));
        let videoID = null;
        try {
            videoID = portfolio.videoLink
                ? new URLSearchParams(new URL(portfolio.videoLink).search).get('v')
                : null
        } catch (err) {
            console.log("Invalid YouTube URL Entered.")
        }

        // const <p>Meeting: {portfolio.zoomMeetingId}, password: {portfolio.zoomMeetingPassword || ''}</p>

        let getZoomSignature = ()=>console.warn('No zoom meeting specified');
        if (this.props.videoSource === 'zoom' && portfolio.zoomMeetingId) {
            const meetingId = portfolio.zoomMeetingId.replace(/ /g, '');
            const passWord = portfolio.zoomMeetingPassword;
            const client = ZoomMtgEmbedded.createClient();
            const authEndpoint = '/zoomauth';
            let sdkKey = null;
            const role = 0;

            /* need to fetch name and email with window.globals.idUser */

            var userName = '';
            var userEmail = '';
            /* 
            As far as I can tell, registrantToken and zakToken are 
            more advanced options for creating new zoom meetings 
            and authenticating users via zoom (as opposed to polyplexus).
            They are included here for reference, but we aren't doing 
            anything with them. [mark 240103]
            */
            var registrantToken = '';
            var zakToken = '';
            

            AjaxFunctions.getCurrentUserData()
                .then(data=>{
                    userName = `${data.user.firstName} ${data.user.lastName}`.trim().replace(/  /g, ' '); 
                    userEmail = data.user.email;
                    console.log("userData", data.user);
                });

            fetch('portfolio/getZoomAuthInfo')
                .then(response=>response.json())
                .then(zoomConfig=>sdkKey = zoomConfig.sdkKey)
                .catch(err=>console.log('err fetching sdkKey', err));
            
            getZoomSignature = (e)=>{
                e.preventDefault();
            
                if (!sdkKey) {
                    console.warn('still fetching zoom config');
                } else {
                    // console.debug(`checking zoom auth from ${authEndpoint}, key ${sdkKey}`);
                    fetch(authEndpoint, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                        meetingNumber: meetingId,
                        role: role
                        })
                    }).then(res => res.json())
                    .then(response => {
                        startMeeting(response.signature)
                    }).catch(error => {
                        console.error(error)
                    });
                }
            }    

            const startMeeting = (signature)=>{
                let meetingSDKElement = document.getElementById('zoom-meeting-container');
                client.init({
                    zoomAppRoot: meetingSDKElement, 
                    language: 'en-US',                   
                    customize: {
                        video: {
                            isResizable: true,
                            viewSizes: {
                                default: {
                                    width: 720,
                                    height: 411
                                }
                            }
                        }
                    }
                }).then(() => {
                    client.join({
                        signature: signature,
                        sdkKey: sdkKey,
                        meetingNumber: meetingId,
                        password: passWord,
                        userName: userName,
                        userEmail: userEmail,
                        tk: registrantToken,
                        zak: zakToken
                    }).then(() => {
                        console.log('joined succesfully')
                    }).catch((error) => {
                        console.log(error)
                    })
                }).catch((error) => {
                    console.log(error)
                })
            };
        }





        let { sponsorTypingResponse } = this.state;
        return (
            <div id={'portfolioDiscussionTab'}>
                {this.props.videoSource === 'youtube' && <YouTube videoId={videoID} />}
                {this.props.videoSource === 'zoom'  && 
                   <div className="portfolio-zoomLink">
                     <button onClick={getZoomSignature}>Join Zoom Meeting</button>
                     <div id="zoom-meeting-container"></div>
                   </div>             
                }
                <Button
                   className={'export-incubator-discussion'}
                   href={'incubator/exportAsDocX?idIncubator=' + portfolio.id}
                   variant='outlined'
                   startIcon={<FontAwesomeIcon icon={['far', "file-word"]} />}
                   style={{ marginBottom: '1em' }}
                >
                    Export Workshop Discussion
                </Button>
                {this.checkIncubatorOwners(window.globals.idUser) &&
                    <div className='new-thread-box'>
                        <Typography variant='h6'>
                            Add a New Thread
                        </Typography>
                        <CommentSubmissionBox
                            allUsers={allUsers}
                            onSubmit={(_, text) => this.handleSubmitThread(_, text)}
                        />
                    </div>
                }
                <DiscussionFAB message={sponsorTypingResponse ? sponsorTypingResponse.message : null}
                    onClick={() => {
                        let comments = this.state.allComments.slice();
                        if(sponsorTypingResponse){
                            expandToShowComment(comments, sponsorTypingResponse.idCardComment);
                        }
                        this.setState({ allComments: comments});
                        //need to wait for a re-render before we can scroll, can this be cleaned up?
                        window.setTimeout(() => {
                            Scroll.scroller.scrollTo(
                               `comment-${sponsorTypingResponse ? sponsorTypingResponse.idCardComment : null}`,
                               {
                                   smooth: true,
                                   offset: -80,
                               }
                            )
                        }, 100)
                    }}
                />

                {pinnedComments.length > 0 &&
                    <div className='comment-section'>
                        {useTopics &&
                            <div className='column-names'>
                                <span className='topic-title'>Thread Title</span>
                                <span className='comment-count'>Comments</span>
                                <span className='latest-comment'>Latest Comment</span>
                            </div>
                        }
                        {pinnedComments}
                    </div>
                }
                <Grid container spacing={2} style={{ marginTop: '1em', marginBottom: '1em' }}>
                    <Grid item xs={2}>
                        <div>
                            <InputLabel style={{ marginRight: '10px' }} id="label">Sort By:</InputLabel>
                            <Select
                                native
                                value={this.state.commentSort}
                                onChange={e => this.setState({ commentSort: e.target.value })}
                                fullWidth
                            >
                                <option value='mr'>Time</option>
                                <option value='ml'>Likes</option>
                            </Select>
                        </div>
                    </Grid>
                    <Grid item xs={10}>
                        <InputLabel style={{ marginRight: '10px' }} id="label">Search:</InputLabel>
                        <TextField onChange={e => this.setState({ discussionSearchFilter: e.target.value })} fullWidth variant='standard' />
                    </Grid>
                </Grid>
                <NewCommentList
                   flatNumberedComments={flatNumberedComments}
                   expandToShowComment={(idComment) => {
                       let comments =this.state.allComments.slice();
                       expandToShowComment(comments, idComment);
                       this.setState({ allComments: comments});
                       //need to wait for a re-render before we can scroll, can this be cleaned up?
                       window.setTimeout(() => {
                           Scroll.scroller.scrollTo(
                              `comment-${idComment}`,
                              {
                                  smooth: true,
                                  offset: -80,
                              }
                           )
                       }, 100)
                   }}
                />
                <div className='comment-section'>
                    {sortedComments.length > 0 ? (
                        <>
                            {useTopics &&
                                <div className='column-names'>
                                    <span className='topic-title'>Thread Title</span>
                                    <span className='comment-count'>Comments</span>
                                    <span className='latest-comment'>Latest Comment</span>
                                </div>
                            }
                            {sortedComments}
                        </>
                    ) : (
                            'No comments'
                        )}
                </div>
                <ConfirmationModal
                    show={showDeleteModal}
                    closeFunction={() => this.setState({ showDeleteModal: false })}
                    confirmFunction={() => this.handleDeleteComment(threadToDelete)}
                    contentText='Are you sure that you want to delete this thread? This action is irreversible.'
                    confirmText='Delete'
                />
            </div>
        );
    }
}

/**
 *
 * @param {object[]} comments
 * @param idComment
 * @returns {boolean}
 */
function expandToShowComment(comments, idComment){
    for(let comment of comments){
        if(comment.idCardComment === parseInt(idComment)){
            comment.shouldExpand = true;
            return true;
        }
        else{
            let shouldExpand = expandToShowComment(comment.childComments, idComment);
            if(shouldExpand){
                comment.shouldExpand = true;
                return true;
            }
        }
    }
    return false;
}
